<template>
    <div>
        <section class="section-padding" id="financiar">
            <div class="container">
                <div class="section-header text-center">
                    <h2>Financia <span>Tu Vehículo</span></h2>
                    <h3>
                        <span>
                            Financiamos a la medida con las mejores tasas para
                            usados del mercado.
                        </span>
                    </h3>
                </div>
                <div class="row">
                    <div class="col-md-5 col-sm-12">
                        <div class="row mt-3">
                            <div
                                class="col-md-12 text-center"
                                v-if="id_consignacion === ''"
                            >
                                <img
                                    src="/assets/images/slider/carros.png"
                                    alt="image"
                                    class="img-fluid"
                                />
                            </div>
                            <div class="col-md-12 text-center" v-else>
                                <b-card>
                                    <b-row>
                                        <b-col md="12" class="text-center mb-2">
                                            <!-- Imagen principal del vehículo -->
                                            <img
                                                :src="
                                                    'https://brokcars-assets.s3.us-east-2.amazonaws.com/' +
                                                        vehiculoData.inspeccion
                                                            .proceso.fotos
                                                            .foto_principal
                                                "
                                                class="img-fluid"
                                                alt="image"
                                            />
                                        </b-col>
                                        <b-col md="12">
                                            <div>
                                                <h4 class="m-0">
                                                    <i class="fa fa-car"></i>
                                                    {{
                                                        vehiculoData.vehiculo
                                                            .marca
                                                    }}
                                                    {{
                                                        vehiculoData.vehiculo
                                                            .linea
                                                    }}
                                                </h4>
                                                <h5 class="grey-text">
                                                    {{
                                                        vehiculoData.vehiculo
                                                            .modelo
                                                    }}
                                                    |
                                                    {{
                                                        vehiculoData.vehiculo
                                                            .kilometraje
                                                            | formatNumber
                                                    }}
                                                    km
                                                </h5>
                                                <h5 class="text-red">
                                                    ${{
                                                        vehiculoData.vehiculo
                                                            .precio_publicacion
                                                            | formatNumber
                                                    }}
                                                </h5>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </div>
                            <div class="row p-5">
                                <div class="col-md-12 mt-5">
                                    <h6 class="text-small">
                                        <span>
                                            <i
                                                class="fa fa-check"
                                                aria-hidden="true"
                                            ></i>
                                            Fácil , flexible y de acuerdo a tu
                                            necesidad.
                                        </span>
                                        <hr />
                                        <span>
                                            <i
                                                class="fa fa-check"
                                                aria-hidden="true"
                                            ></i>
                                            Planes y alternativas de acuerdo a
                                            su capacidad de pago.
                                        </span>
                                        <hr />
                                        <span>
                                            <i
                                                class="fa fa-check"
                                                aria-hidden="true"
                                            ></i>
                                            Trabajamos de la mano con todos los
                                            bancos.
                                        </span>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 col-sm-12 ">
                        <calculadoraForm v-if="asistenteStepData == ''" />
                        <creditoForm v-if="asistenteStepData == 'cliente'" />
                        <responseForm v-if="response" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import calculadoraForm from "./frontFormCalculadora";
import creditoForm from "./frontFormCredito";
import responseForm from "./frontFormResponse";
export default {
    data() {
        return {
            response: false
        }
    },
    components: {
        calculadoraForm,
        creditoForm,
        responseForm
    },
    computed: {
        asistenteStepData() {
            return this.$store.state.financiar.asistente_step;
        },
        ...mapFields("financiar", [
            "id_consignacion",
            "vehiculoData",
            "asistente_step",
            "credito.v_vehiculo"
        ])
    },
    mounted() {
        var path = window.location.pathname;
        if(path === '/financiar/response') {
            this.response = true;
            this.asistente_step = 'response';
        }else {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            var ficha_tecnica = urlParams.get("ficha_tecnica");
            if (ficha_tecnica) {
                this.id_consignacion = ficha_tecnica;
                this.search_consignacion();
            }
        }
    },
    methods: {
        search_consignacion() {
            axios
                .get("/search_consignacion/" + this.id_consignacion)
                .then(response => {
                    var responseData = response.data;
                    this.vehiculoData = responseData.vehiculo;
                    this.v_vehiculo = this.vehiculoData.vehiculo.precio_publicacion;
                });
        }
    }
};
</script>
<style lang="scss">
h6.text-small {
    font-size: 15px;
}
</style>
